"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeferred = exports.doWhile = exports.delay = void 0;
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
exports.delay = delay;
async function doWhile(doFn, whileFn) {
    do {
        await doFn();
    } while (await whileFn());
}
exports.doWhile = doWhile;
function getDeferred() {
    let resolve = undefined;
    let reject = undefined;
    let promise = new Promise((resolveCb, rejectCb) => {
        resolve = resolveCb;
        reject = rejectCb;
    });
    // TS thinks we're using these before they're assigned, which is why
    // we need the undefined types, and the any here.
    return { resolve, reject, promise };
}
exports.getDeferred = getDeferred;
//# sourceMappingURL=promises.js.map